module.exports = __webpack_public_path__ + "img/start.479dc102.png";